(function () {
  var ANIMATION_DURATION = 320;

  function shouldReduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function waitForContentTransition(item, callback) {
    var content = item.querySelector('.speakon-faq-item__content');
    var finished = false;

    function done() {
      if (finished) return;
      finished = true;

      if (content) {
        content.removeEventListener('transitionend', handleTransitionEnd);
      }

      callback();
    }

    function handleTransitionEnd(event) {
      if (event.target === content && event.propertyName === 'grid-template-rows') {
        done();
      }
    }

    if (!content || shouldReduceMotion()) {
      done();
      return;
    }

    content.addEventListener('transitionend', handleTransitionEnd);
    window.setTimeout(done, ANIMATION_DURATION + 80);
  }

  function expandItem(item) {
    if (item.dataset.expanded === 'true') return;

    if (shouldReduceMotion()) {
      item.open = true;
      item.dataset.expanded = 'true';
      return;
    }

    item.open = true;
    item.dataset.animating = 'true';

    window.requestAnimationFrame(function () {
      item.dataset.expanded = 'true';

      waitForContentTransition(item, function () {
        delete item.dataset.animating;
      });
    });
  }

  function collapseItem(item) {
    if (item.dataset.expanded !== 'true') return;

    if (shouldReduceMotion()) {
      delete item.dataset.expanded;
      item.open = false;
      return;
    }

    item.dataset.animating = 'true';
    delete item.dataset.expanded;

    waitForContentTransition(item, function () {
      item.open = false;
      delete item.dataset.animating;
    });
  }

  function initFaq(root) {
    var sections = root.querySelectorAll('[data-speakon-faq]');

    sections.forEach(function (section) {
      if (section.dataset.faqInitialized === 'true') return;

      var allowMultiple = section.dataset.allowMultiple === 'true';
      var items = Array.prototype.slice.call(section.querySelectorAll('[data-speakon-faq-item]'));

      if (!items.length) return;

      section.dataset.faqInitialized = 'true';

      if (!allowMultiple) {
        var firstOpenFound = false;

        items.forEach(function (item) {
          if (!item.open) return;

          if (firstOpenFound) {
            item.open = false;
            return;
          }

          item.dataset.expanded = 'true';
          firstOpenFound = true;
        });
      } else {
        items.forEach(function (item) {
          if (item.open) {
            item.dataset.expanded = 'true';
          }
        });
      }

      items.forEach(function (item) {
        var summary = item.querySelector('summary');

        if (!summary) return;

        summary.addEventListener('click', function (event) {
          event.preventDefault();

          if (item.dataset.animating === 'true') return;

          if (item.dataset.expanded === 'true') {
            collapseItem(item);
            return;
          }

          if (!allowMultiple) {
            items.forEach(function (otherItem) {
              if (otherItem !== item) {
                collapseItem(otherItem);
              }
            });
          }

          expandItem(item);
        });
      });

      document.addEventListener('shopify:block:select', function (event) {
        if (!event.target || !event.target.closest) return;

        var selectedItem = event.target.closest('[data-speakon-faq-item]');

        if (!selectedItem || !section.contains(selectedItem)) return;

        if (!allowMultiple) {
          items.forEach(function (item) {
            if (item !== selectedItem) {
              collapseItem(item);
            }
          });
        }

        expandItem(selectedItem);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFaq(document);
    });
  } else {
    initFaq(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFaq(event.target);
  });
})();
